module.exports = __webpack_public_path__ + "img/5.268459c2.png";